import { ConnectionNames } from "../../Contracts";
import { storeToken, tokenRenewHandler } from "../../Common";
const handlers = [
    tokenRenewHandler(ConnectionNames.sports),
    tokenRenewHandler(ConnectionNames.openBets),
    tokenRenewHandler(ConnectionNames.betslip, true)
];
export function onTokenRenew(payload) {
    handlers.forEach(handler => {
        handler(payload);
    });
    storeToken(payload.data[0].token);
}
//# sourceMappingURL=OnTokenRenew.js.map